import { Component } from '@angular/core';
import { DialogContainerComponent } from '../dialog-container/dialog-container.component';

@Component({
  selector: 'custom-dialog-container',
  templateUrl: './custom-dialog-container.component.html',
})
export class CustomDialogContainerComponent extends DialogContainerComponent {

}
